module.exports = __webpack_public_path__ + "img/edu-banner-catalogue.af16f288.svg";